import script from "./DisclaimerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DisclaimerModal.vue?vue&type=script&setup=true&lang=js"

import "./DisclaimerModal.vue?vue&type=style&index=0&id=67c2b3b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c2b3b7"]])

export default __exports__